import React from 'react'

const Home = () => {
  return (
    <>
      <h1>Hello, welcome to my blog!</h1>
      <p>
        Full Stack (MERN) blog web application!<br /><br />
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Repudiandae, at quis! Fugit blanditiis velit voluptatem
        commodi vitae repellat perferendis pariatur laudantium
        deleniti iste, fugiat consequatur vel corporis earum voluptates
        labore? Soluta voluptatem sequi nemo sunt aliquid sapiente aut
        odit, odio iste sint velit quam dolor at officiis,
        voluptatibus recusandae? Tempore!
      </p>
      <button ><a target='_blank' href="https://github.com/jamilahmed2/blog-app">Github Repo</a></button>
    </>
  )
}

export default Home